module.exports = __webpack_public_path__ + "Repunta pipe-1-9ca054644289a4aae26f8cfe685ab2b4.png";